import React from 'react';
import { useLogout } from '../../hooks/use-logout.hook';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { LogoutOutlined } from '@ant-design/icons';

export default function LogoutButton({ icon }: { icon?: React.ReactNode }) {
  const logout = useLogout('/');
  const { t } = useTranslation();

  return (
    <Button type="text" onClick={logout} icon={icon ? icon : <LogoutOutlined />}>
      {t('common.logout')}
    </Button>
  );
}
